"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const common_styled_components_1 = require("../../../common-styled-components");
const optionUtil_1 = require("../../../../util/compliance/optionUtil");
const lodash_1 = require("lodash");
const react_1 = require("react");
const emptyEngineOption = (0, optionUtil_1.getEmptyOption)("engine");
const emptyEngineRoleOption = (0, optionUtil_1.getEmptyOption)("engine role");
const EngineEditor = ({ metadata, updateEngine, index, initialValue, remove, }) => {
    const [engine, setEngine] = (0, react_1.useState)(initialValue ?? {
        type: 1,
        ship_engine_type: 1,
    });
    (0, react_1.useEffect)(() => {
        updateEngine(index, engine);
    }, [engine]);
    const engineOptions = [emptyEngineOption].concat(metadata
        ? (0, lodash_1.values)(metadata.engines).map((e) => ({
            label: e.engine.description,
            value: e.engine.engine,
        }))
        : []);
    const engineRoleOptions = [emptyEngineRoleOption].concat(metadata
        ? Object.keys(metadata.ship_engine_type).map((key) => ({
            label: metadata.ship_engine_type[Number(key)],
            value: Number(key),
        }))
        : []);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SeparatedRow, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SelectorLabel, { children: ["Engine ", index + 1] }), remove && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => remove(index), children: "- Remove" }))] }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: engineOptions, onChange: (newValue) => newValue &&
                        newValue.value !== null &&
                        setEngine({
                            ...engine,
                            type: newValue.value,
                        }), value: engineOptions.find((o) => engine.type === o.value) ??
                        emptyEngineOption, isOptionSelected: (option) => option.value === engine.type }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: engineRoleOptions, onChange: (newValue) => newValue &&
                        newValue.value !== null &&
                        setEngine({
                            ...engine,
                            ship_engine_type: newValue.value,
                        }), value: engineRoleOptions.find((o) => engine.ship_engine_type === o.value) ?? emptyEngineRoleOption, isOptionSelected: (option) => option.value === engine.ship_engine_type })] }) }));
};
exports.EngineEditor = EngineEditor;
